<template><section><h3>面向多型潜航器的多模态空间感知与潜浮均衡协同决策系统</h3>
<h4>背景介绍：</h4>
<p>深潜救生艇是一种具备航行能力，可与潜艇救生平台对接，用于援救失事潜艇艇员的载人潜水器，通常由母船搭载，是实施潜艇救生的主要装备。深潜救生艇在执行水下对接、艇员转移及返航等任务过程中，艇体载荷和人员分布会随任务进程持续变化，潜浮均衡状态需要及时调整。现有均衡作业涉及艇型参数多、物理计算专业性强、操作规则和安全约束复杂，在紧急任务条件下，对人员计算经验、操作熟练程度和现场快速处置能力要求较高。同时，深海任务现场网络条件受限，关键决策又不能依赖外部云端服务或完全交由人工智能自主完成。因此，有必要将确定性物理计算、专业规则、离线智能交互、状态可视化与人工决策有机结合，在保证安全关键计算可信可控的基础上，降低复杂工况下的信息输入、状态理解和方案判断负担。</p>
<h4>项目要求：</h4>
<ol>
<li>
<p>多模态输入与语义结构化解析</p>
<ul>
<li>实现语音与文本双通道输入，完成本地语音识别（ASR）与大语言模型（LLM）的离线部署与联调。系统能够从自然语言描述中准确提取艇员体重、座位编号、水舱注排水状态、压载铁数量与位置、当前任务阶段等关键参数，并输出符合预定义JSON Schema的结构化工况描述。关键参数提取准确率不低于90%，单次语义解析响应时间不超过3秒（本地GPU/CPU推理）。</li>
</ul>
</li>
<li>
<p>潜浮均衡确定性求解与规则校验引擎</p>
<ul>
<li>建立覆盖至少2种典型潜航器构型（如DSRV型、SRV型）的静力学均衡模型，包括浮力-重力平衡、纵倾力矩平衡、横倾力矩平衡计算。实现压载水舱注排水量、压载铁增减、人员移座等操作变量的组合优化求解，输出满足姿态角约束（纵倾≤±2°、横倾≤±1°）、浮力裕度约束和操作安全规则的候选均衡方案集（不少于3个排序方案）。所有计算过程可追溯、可复现，不依赖任何黑箱模型。</li>
</ul>
</li>
<li>
<p>三维空间态势感知与可视化交互</p>
<ul>
<li>构建潜航器三维数字孪生场景，实时映射艇体六自由度姿态、艇员座位分布、各水舱液位、压载配置及重心/浮心位置。支持均衡方案的前后对比动画演示、操作序列逐步回放、关键参数超限告警高亮。三维场景帧率不低于30 fps，支持鼠标/触控旋转、缩放、剖面查看，并提供与物理计算结果联动的数据面板。</li>
</ul>
</li>
<li>
<p>人机协同决策流程与操作建议生成</p>
<ul>
<li>设计&quot;AI建议—人工确认—执行反馈&quot;的闭环决策流程。系统在完成均衡求解后，以自然语言摘要+结构化表格+三维动画三种形式向用户呈现候选方案及推荐理由，标注各方案的风险点与约束裕度。用户可通过语音或点击进行方案选择、参数微调与二次求解。全流程操作留痕，支持事后回放与审计。</li>
</ul>
</li>
</ol>
</section></template><script>export default {components:{}}</script>